<template>
  <div class="popup">
    <div class="popup__overlay" @click="closeModal"></div>
    <div class="popup__inner" >
      <div class="popup__inner__details">
        <div  v-if="!apply" id="vjs-tab-job" data-tab-bind="job" >
          <div v-html="dataPage"></div>
        </div>
        <form  class="tab-content apply-form show  has-logo ng-pristine ng-valid ng-valid-email">


          <!-- ************************| Tab 1 |************************ -->

          <div class="tab-pane active" v-if="!submitStatus ">

            <div class="tab-transition-container">
              <div class="center-container" >

                <h1>Inquiry</h1>
                <!-- <p class=s"intro">Let us get to know you a bit better by sharing your basic info.</p> -->


                <ul class="form-layout">
                  <li class="input-half">
                    <label data-label="first_name">First name *</label>
                    <input type="text" v-model.trim="$v.FirstName.$model" :class="{ 'error': $v.FirstName.$error,'valid':!$v.FirstName.$invalid }" name="first_name" ng-model="formData.first_name" ng-init="formData.first_name=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>

                  <li class="input-half">
                    <label data-label="last_name">Last name *</label>
                    <input type="text" v-model.trim="$v.Last_name.$model" name="last_name" :class="{ 'error': $v.Last_name.$error,'valid':!$v.Last_name.$invalid }" ng-model="formData.last_name" ng-init="formData.last_name=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>
                <li>
                    <label data-label="company">
                      Company Name
                    </label>
                    <input type="text" v-model.trim="$v.Company.$model" :class="{ 'error': $v.Company.$error,'valid':!$v.Company.$invalid }" name="country" 
                      class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>
                  <li>
                    <label data-label="email">E-mail address *</label>
                    <input type="email" v-model="Email_address" v-model.trim="$v.Email_address.$model"  name="email" ng-model="formData.email" :class="{ 'error': $v.Email_address.$error,'valid':!$v.Email_address.$invalid }" ng-init="formData.email=''"
                      class="ng-pristine ng-untouched ng-valid ng-empty ng-valid-email">
                  </li>
                  <li>
                    <label data-label="phone_number">
                     Phone number
                    </label>
                    <input type="tel" v-model="Telephone_number" v-model.trim="$v.Telephone_number.$model" :class="{ 'error': $v.Telephone_number.$error,'valid':!$v.Telephone_number.$invalid }" name="phone_number" ng-model="formData.phone_number"
                      ng-init="formData.phone_number=''" class="ng-pristine ng-untouched ng-valid ng-empty">
                  </li>
                </ul>
               

              <vue-recaptcha
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              @render="onCaptchaRendered"
              size="checkbox"
              :sitekey="this.sitekey">
              </vue-recaptcha>
             <div class="tab-control  next" style="    transform: scale(0.5); font-size: 45px;cursor: pointer;" @click="submit()">
          
            <span>send</span>
                </div>

              </div>
 
            </div>
          </div>
          <p  v-else class="sentsuccesfully ">
            Sent succesfully 
          </p>
        </form>

      </div>
     
      <div class="popup__inner__close" @click="closeModal()">
        <i class="popup__inner__close__icon"></i>
      </div>

    </div>


  </div>
</template>

<script>
  import EventBus from '@/event-bus';
  import { required, minLength,email,numeric } from 'vuelidate/lib/validators';
  import axios from 'axios';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'popup',
    data() {
      return {
        sitekey: "6LeKEokaAAAAANt--Lbr__JFA9Dcmm0ncQ0lEMLc",
        widgetId: '',
        recaptchaStatus:false,
        isActive: undefined,
        selectedCupId: undefined,
        isOpen: false,
        apply: false,
        FirstName:"",
        Last_name :"",
        Email_address :"",
        City:"",
        Company:"",
        Telephone_number:"",
        dataPage:"",
        submitStatus:false,
        file:'',
      };
    },
    validations: {
      // file: {required},
    FirstName: {
      required,
      minLength: minLength(4)
    },
    Last_name: {
      required,
      minLength: minLength(4)
    },
    Email_address: {
      required,
     email
    },
     Company: {
      required,
      minLength: minLength(4)
    }, 
    Telephone_number: {
      required,
      numeric
    },

    },
    props: {
      pakketData: {},
    },
    created() {
      // this.selectedCupId = this.selectedCupId || this.pakketData.content[0].id;
    },
    methods: {
      closeModal() {
        EventBus.$emit('close-modal', undefined);
      },
      submit() {
      console.log('submit!');
      this.submitStatus = true ; 

      this.$v.$touch();

      if (this.$v.$invalid  ||  !this.recaptchaStatus ) {
      
        setTimeout(function(){
          if($(".popup__inner .error")){
              $(".popup__inner .error")[0].scrollIntoView()
          }

        },100)
    
      } else {
      console.log('done!');
          this.file = this.$refs.file.files[0];   
          let formData = new FormData();
          formData.append('Email',this.Email_address);
          formData.append('PhoneNumber',this.Telephone_number);
          formData.append('LastName',this.Last_name );
          formData.append('CareerLocation',this.pakketData.location);
          formData.append('Company',this.Company);
          formData.append('FirstName',this.FirstName);
          this.submitStatus = true ; 
          axios.post('https://superapi.mobilityintel.com/api/LandingPage/ApplyJob',
          formData,
           {headers: {
              'Content-Type': 'multipart/form-data'
            }},
          ).then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
        // do your submit logic here
        this.submitStatus = 'PENDING'
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }
    },
      setToken: function(token) {
                this.form['g-recaptcha-response'] = token;
      },
      onCaptchaVerified: function(token) {
          this.recaptchaStatus = true;
      },
      onCaptchaExpired: function() {
          this.setToken('');
      },
      onCaptchaRendered: function(id) {
          this.widgetId = id;
      },
    },
    mounted(){
        //   axios.get(this.pakketData.fileurl).then(response => {
        //   //  axios.get("https://landingpageconf.s3.amazonaws.com/Data_Analysis_Specialist_qsdqdd.html").then(response => {
        //    this.dataPage = response.data;
        // });

       
    },
    components:{VueRecaptcha}

  }

</script>

<style lang="scss" scoped>
  @import './../popup/style';

    .popup__inner{
    max-width: 563px !important;
    background: rgba(255, 255, 255 , 0.2);
    -webkit-backdrop-filter: blur(9px);
    backdrop-filter: blur(9px);
    padding: 52px 20px;
    }
    form.apply-form .center-container {
       border-radius: 5px;
    }
    .tab-content > .tab-pane{
        padding: 0;
    }
    .popup__inner__close__icon{
    background-image: url("data:image/svg+xml,%0A%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='29.5px' height='29.6px' viewBox='0 0 29.5 29.6' style='enable-background:new 0 0 29.5 29.6;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cg transform='translate(0.000000,30.000000) scale(0.100000,-0.100000)'%3E%3Cpath class='st0' d='M10.3,289.7c-19-19-15-30,40-85l52-53l-53-54c-36-37-52-60-48-70c14-36,38-29,93,25l54,53l54-53 c37-36,60-52,70-48c36,14,29,38-25,93l-53,54l53,54c54,55,61,79,25,93c-10,4-33-12-70-48l-54-53l-53,52 C40.3,304.7,29.3,308.7,10.3,289.7z'/%3E%3C/g%3E%3C/svg%3E%0A");
    }
</style>
// 


// WEBPACK FOOTER //
// src/components/Sectors/contact.vue